import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/listLayoutBar.module.scss';
import { isMobileAny } from '../../../../utils/device';
import { ErrorBoundary } from '../../../../components/ErrorBoundary';

export const ListLayoutBar: FC<
	React.PropsWithChildren<{
		className?: string;
	}>
> = ({ children, className }) => {
	const componentClasses = classNames(
		classes.listPageBar,
		{
			[classes.listPageBar_mobile]: isMobileAny,
		},
		className,
	);
	return (
		<ErrorBoundary>
			<section className={componentClasses}>{children}</section>
		</ErrorBoundary>
	);
};
